import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { COLORS } from 'src/sass/colors.generated';

import { FlexComponent } from '../../flex/flex.component';

@Component({
  selector: 'app-frame-with-title',
  templateUrl: './frame-with-title.component.html',
  styleUrls: ['./frame-with-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FlexComponent],
})
export class FrameWithTitleComponent {
  @Input() direction: 'row' | 'column' | 'row-reverse' | 'column-reverse' = 'column';
  @Input() justify: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly' =
    'flex-start';
  @Input() align: 'stretch' | 'flex-start' | 'flex-end' | 'center' | 'baseline' = 'stretch';
  @Input() wrap: 'nowrap' | 'wrap' | 'wrap-reverse' = 'nowrap';
  @Input() padding = '';
  @Input() margin = '';
  @Input() textAlign: 'center' | 'left' | 'right' = 'center';
  @Input() height = 'auto';
  @Input() width = '1360px';
  @Input() title = '';
  @Input() subTitle = '';
  @Input() backgroundColor: string = COLORS.WHITE;
  @Input() fontSize = 48;
}
